import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const LandingPageObjClass = Scrivito.provideObjClass("LandingPage", {
  attributes: {
    ...defaultPageAttributes,
    body: [
      "widgetlist",
      {
        only: [
          "HeroWidget",
          "FeatureWidget",
          "AccordionFeatureWidget",
          "TestimonialWidget",
          "SliderWidget",
          "LogoSliderWidget",
          "StorylaneWidget",
          "BenefitsWidget",
          "FeatureOverviewWidget",
          "FinalCallToActionWidget"
        ]
      }
    ]
  },
  extractTextAttributes: ["description", "body"]
})

export type LandingPage = InstanceType<typeof LandingPageObjClass>
export type LandingPageAttributes = ScrivitoAttributes<LandingPage>
